export const MAXIMUM_NUMBER_OF_FAVOURITE_FARMS_ERROR_MESSAGE =
  'The maximum amount of favourite farms has been reached.';
export const MAXIMUM_NUMBER_OF_FAVOURITE_FARMS_ALLOWED = 30;
export const NO_FAVOURITE_FARMS_MESSAGE = 'No favourite farms';
